import { money } from "@/components/admin-control/BalanceChart";

export const timeAgo = (iso) => {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export function Avatar({ u, size = "h-10 w-10 text-sm" }) {
  return <span className={`${size} shrink-0 rounded-full flex items-center justify-center font-bold text-white`} style={{ backgroundColor: u.color }}>{u.initials}</span>;
}

export function ProBadge({ id }) {
  return <span data-testid={id} className="text-[10px] font-bold tracking-wider text-[#F5C451] border border-[#F5C451]/70 rounded px-1.5 py-[1px]">PRO</span>;
}

export function UserRow({ u, currency, onOpen }) {
  return (
    <li>
      <button data-testid={`user-row-${u.user_id}`} onClick={() => onOpen(u)}
        className="w-full flex items-center gap-3 py-3 border-b border-white/5 text-left hover:bg-white/[0.03] -mx-2 px-2 rounded-lg transition-colors">
        <Avatar u={u} />
        <div className="min-w-0 flex-1">
          <p className="flex items-center gap-2">
            <span className="font-bold text-white truncate">{u.name}</span>
            {u.is_pro && <ProBadge id={`user-pro-${u.user_id}`} />}
            {u.banned && <span className="text-[10px] font-bold text-red-400 border border-red-400/60 rounded px-1.5 py-[1px]">BANNED</span>}
          </p>
          <p className="text-xs text-zinc-400 truncate">{u.email}</p>
        </div>
        <div className="text-right shrink-0">
          <p className="text-[10px] uppercase tracking-wider text-zinc-500">Contribution</p>
          <p data-testid={`user-contribution-${u.user_id}`} className="text-sm font-semibold text-white">{u.contribution > 0 ? money(u.contribution, currency) : "—"}</p>
        </div>
      </button>
    </li>
  );
}

export function KpiGrid({ totalUsers, premiumTier, netBalance, currency }) {
  const items = [
    { k: "total-users", label: "Total Users", value: totalUsers, cls: "text-white" },
    { k: "premium-tier", label: "Premium Tier", value: premiumTier, cls: "text-[#22C55E]" },
    { k: "net-balance", label: "Net Balance", value: money(netBalance, currency), cls: "text-white" },
  ];
  return (
    <div className="grid grid-cols-3 gap-2 mt-4">
      {items.map((i) => (
        <div key={i.k} className="rounded-xl bg-[#121214] border border-white/5 px-3 py-3 min-w-0">
          <p className="text-[10px] uppercase tracking-wider text-zinc-500">{i.label}</p>
          <p data-testid={`kpi-${i.k}`} className={`text-lg font-bold mt-0.5 truncate ${i.cls}`}>{i.value}</p>
        </div>
      ))}
    </div>
  );
}

export function Stars({ n, id }) {
  return (
    <div data-testid={id} className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <svg key={i} viewBox="0 0 20 20" className="h-4 w-4" data-filled={i <= n}>
          <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.5 7.7l5.9-.9z" fill={i <= n ? "#F5C451" : "#3F3F46"} />
        </svg>
      ))}
    </div>
  );
}

export function FeedbackCard({ f, i }) {
  return (
    <div data-testid={`feedback-card-${i}`} className="rounded-xl bg-[#121214] border border-white/5 p-4">
      <div className="flex items-center justify-between">
        <span className="font-semibold text-white text-sm">{f.name}</span>
        <span className="text-xs text-zinc-500">{timeAgo(f.created_at)}</span>
      </div>
      <div className="mt-2"><Stars n={f.stars} id={`feedback-stars-${i}`} /></div>
      <p className="text-sm text-zinc-300 mt-2 leading-relaxed">{f.comment}</p>
      {f.pair && <p className="text-[11px] text-zinc-500 mt-1">{f.pair}</p>}
    </div>
  );
}
